import React from 'react';

export function Radio({ label, checked = false, onChange, disabled = false, name }) {
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? .5 : 1, fontSize: 'var(--fs-body-md)', color: 'var(--text-1)' }}>
      <span
        onClick={() => !disabled && onChange && onChange()}
        style={{
          width: 18, height: 18, borderRadius: '50%', flex: 'none',
          border: `1.5px solid ${checked ? 'var(--brand-primary)' : 'var(--border-strong)'}`,
          background: 'var(--surface-1)', display: 'grid', placeItems: 'center',
        }}
      >
        {checked && <span style={{ width: 9, height: 9, borderRadius: '50%', background: 'var(--brand-primary)' }} />}
      </span>
      {label}
      <input type="radio" name={name} checked={checked} readOnly style={{ display: 'none' }} />
    </label>
  );
}
